<script lang="ts" setup>
	import type { IconLibProps } from '../tools/icon.vue'

	export type usedHospitalContext = {
		name: {
			text: string
			icon?: Partial<IconLibProps>
		}
		location: {
			text: string
			icon?: Partial<IconLibProps>
		}
	}

	const { count = 2 } = defineProps<{
		list: usedHospitalContext[]
		count?: number
	}>()
</script>

<template>
	<div class="w-full">
		<ui-title-header
			:ui="{
				size: 'text-[2rem]/[2.4rem] md:text-[2.625rem]/[3.15rem] lg:text-[3.25rem]/[3.9rem]',
				lineHeight: ''
			}"
			class="text-center mx-auto w-full sm:sticky top-[6rem] sm:top-[6rem] bg-current left-0 z-10 pt-5"
		>
			<span class="max-w-[938px] inline-flex">Experience great care at the hospitals closest to you</span>
		</ui-title-header>
		<p class="text-gray-600 md:text-xl mt-3 sm:mt-8 text-center">
			Networks of great hospitals accessible to your staff
		</p>

		<div
			class="flex sm:mt-24 mt-10 items-center sm:gap-x-8 invisible-scrollbar overflow-hidden justify-between sm:overflow-x-hidden overflow-x-auto w-full"
		>
			<!-- moveX -->
			<div class="flex sm:gap-x-8 sm:mr-5 w-full moveX animation-pause-onhover flex-none">
				<template v-for="(item, index) in count" :key="index">
					<div
						class="flex gap-x-3 sm:gap-x-8 mr-5 flex-none min-w-[1100px] flex-row-reverse sm:min-w-[1240px]"
					>
						<div
							v-for="(item, index) in list"
							:key="'hospital-' + index"
							class="md:max-w-[400px] max-w-[320px] group hover:bg-health-50 transition hover:border-health-300 w-full px-5 py-5 sm:py-8 bg-[#FAFBFD] min-h-[210px] md:min-h-[315px] rounded-xl border border-gray-300"
						>
							<div
								class="md:h-[64px] h-[36.3px] w-[36.3px] md:w-[64px] rounded-full overflow-hidden bg-auto-50 border border-auto-100 flexed justify-end flex-col"
							>
								<tools-icon
									:icon="item?.name?.icon?.icon ?? 'hospital-building'"
									:dir="item?.name?.icon?.dir ?? 'random'"
									v-bind="item?.name?.icon"
									svg-class="w-[31.46px] h-[31.46px] md:w-[55.47px] md:h-[55.47px] "
								/>
							</div>

							<strong
								class="font-semibold transition ease-in-out group-hover:text-health-500 tracking-wide text-gray-700 sm:text-2xl text-base xs:text-xl mt-8 block"
							>
								{{ item.name.text }}
							</strong>

							<ul class="content mt-3 space-y-5">
								<li
									class="flex gap-x-3 items-center text-sm group-hover:font-medium transition ease-in-out sm:text-base"
								>
									<tools-icon dir="random" icon="hospital" path-class="group-hover:fill-health-500" />
									<span class="text-gray-600">Hospital</span>
								</li>

								<li
									class="flex gap-x-3 items-start text-sm group-hover:font-medium transition ease-in-out sm:text-base"
								>
									<tools-icon
										:dir="item?.location?.icon?.dir ?? 'random'"
										:icon="item?.location?.icon?.icon ?? 'location'"
										v-bind="item?.location?.icon"
										path-class="group-hover:fill-health-500"
									/>
									<span class="text-gray-600 max-w-[329px]">
										{{ item?.location?.text ?? '' }}
									</span>
								</li>
							</ul>
						</div>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>
